import React from 'react'

const BlogPage = () => {
  return (
    <div>BlogPage</div>
  )
}

export default BlogPage